import * as React from "react";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import { Logo } from "@utdanningsdirektoratet/logo";
import { LinkButton } from "@utdanningsdirektoratet/button";
import { Icon } from "@utdanningsdirektoratet/icon";
import styles from "./Footer.module.less";
import { useStore } from "../Page";

type Link = {
  href: string;
  title: string;
};

type FooterProps = {
  tjenestenavn?: string;
  linkButton?: Link;
  udirLogo?: boolean;
  items: Array<React.ReactElement>;
  className?: string;
  children?: React.ReactNode;
};

const Footer: React.FC<FooterProps> = ({
  items,
  children,
  className,
  tjenestenavn,
  linkButton,
  udirLogo = false,
}) => {
  const [height, setHeight] = React.useState("8rem");
  const ref = React.useRef<HTMLElement>(null);

  const [, setState] = useStore();

  React.useLayoutEffect(() => {
    setState((prev) => ({ ...prev, footerPanel: true }));
    return () => {
      setState((prev) => ({ ...prev, footerPanel: true }));
    };
  }, [setState]);

  const footerLinks = items.map((item, i) => {
    return (
      <li key={i} className={styles.footerListItem}>
        {React.cloneElement(item, { className: styles.footerLink })}
      </li>
    );
  });
  const listClass = cls({
    [styles.footerList]: true,
  });

  React.useEffect(() => {
    function handleResize() {
      if (ref.current?.clientHeight) setHeight(`${ref.current.offsetHeight}px`);
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  React.useEffect(() => {
    document.documentElement.style.setProperty("--footer-height", height);
    return () => {
      document.documentElement.style.setProperty("--footer-height", "0px");
    };
  }, [height]);

  return (
    <footer ref={ref} className={cls(styles.footer, className)}>
      {udirLogo && <Logo className={styles.footerLogo} negative />}
      <div className={styles.footerContent}>
        {tjenestenavn && `${tjenestenavn} er levert av Utdanningsdirektoratet.`}
        <ul className={listClass}>{footerLinks}</ul>
        {children}
      </div>
      {linkButton && (
        <LinkButton
          className={styles.footerLinkButton}
          href={linkButton.href}
          color="vy"
        >
          {linkButton.title}
          <Icon icon="north east" placement="after" />
        </LinkButton>
      )}
    </footer>
  );
};

export default Footer;
